// extracted by mini-css-extract-plugin
export default {"banner":"MediaRoute_banner__QL4BM","banner-video":"MediaRoute_banner-video__8Vi0k"};